export default __webpack_public_path__ + "static/media/7.70757b9c.jpg";